/** APT owner */
export const APT_OWNER = 'APT';

export const EXPERIENCE_TEMPLATE_TAG = 'ExperienceTemplate';
export const EXPERIENCE_TEMPLATE_APP_KEY = 'ExperienceTemplate';
export const EXPERIENCE_TEMPLATE_TAG_SCHEMA = {
  type: 'string',
  title: EXPERIENCE_TEMPLATE_APP_KEY,
};
